module.exports = __webpack_public_path__ + "img/productions_26.adb5f439.png";